export default "__VITE_ASSET__BeuXZFLD__"